// src/components/ui/drawer.jsx
import * as React from "react"
import { Dialog } from "@headlessui/react"
import { XIcon } from "lucide-react"

export const Drawer = ({ open, onOpenChange, children }) => {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} className="fixed inset-0 z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" onClick={() => onOpenChange(false)}></div>
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-xl overflow-auto">
        {children}
      </div>
    </Dialog>
  );
};

export const DrawerTrigger = ({ children, onClick }) => (
  <button onClick={onClick}>{children}</button>
);

export const DrawerContent = ({ children, onClose }) => (
  <div className="p-6 relative">
    <button
      className="absolute top-4 right-4 text-gray-500 hover:text-black"
      onClick={onClose}
    >
      <XIcon className="w-5 h-5" />
    </button>
    {children}
  </div>
);
